export default "__VITE_ASSET__AU3UQdKd__"